
import { getRoomPrinter, updatePrinter, getPrintDetails, userSetting, getUserSetting, AddQtyPrint } from '@/api/printer'
import axios from 'axios'
import Swal from "sweetalert2";
import Vue from 'vue'
// import i18n from '@/plugins/i18n'
import moment from 'moment'

export const state = {
    printers: [],
    room_printers: [
    ],
    api_printer: "http://localhost:8082/",
    printDetails: [],
    userSetting: {},
    loading: false

}

export const getters = {
    printers: state => state.printers,
    room_printers: state => state.room_printers,
    api_printer: state => state.api_printer,
    printDetails: state => state.printDetails,
    userSetting: state => state.userSetting,
    loading: state => state.loading,
}

export const mutations = {
    PRINTERS(state, payload) {
        state.printers = payload;
    },
    ROOM_PRINTERS(state, payload) {
        state.room_printers = payload;
    },

    PRINT_DETAILS(state, payload) {
        state.printDetails = payload;
    },
    loadingSetting(state, payload) {
        state.loading = payload;
    },
    Setting(state, payload) {
        state.userSetting = payload;
        state.api_printer = payload.value
    }
}



export const actions = {
    async getRoomPrinters({ commit, getters }, payload) {
        const data = await getRoomPrinter(payload);
        commit('ROOM_PRINTERS', data)
    },
    async getPrinter({ commit, getters }) {
        const data = await axios.get(getters.api_printer + "printer").catch(function (error) {
            Swal.fire({
                title: 'Printer Error',
                text: "Printer Service is not define!",

            })
        })
        commit('PRINTERS', data.data.data)
    },
    async sendOrderToPrinter({ commit, getters }, payload) {

        if (!getters.userSetting.value) {
            Swal.fire({
                title: 'Printer Error',
                text: "Printer Service is config",

            });
            return;
        }
        const order = payload
        const response = await getPrintDetails(order.id)
        let data_printed = []
        let printedRoom = '';
        for (let row of response) {
            printedRoom = printedRoom + ' ' + row.print_location_name
            let html = '';
            row.items.forEach(
                function (el, i) {
                    let html_option = ''
                    el.options.forEach(ol => {
                        html_option = html_option + '<p>'
                        html_option = html_option + `${ol.option_name}: `
                        ol.values.forEach(ll => {
                            html_option = html_option + `${ll.value_name}, `
                        });
                        html_option = html_option + '</p>'
                    });
                    var note = el.note ? ', note: ' + el.note : ''
                    html += `<tr>
                                <td class="bottline">${i + 1}</td> 
                                <td class="bottline">${el.item_name}   ${html_option} ${note} </td>
                                <td class="bottline">${el.print_qty}</td>
                            </tr>`;
                    data_printed.push({ sale_detail_id: el.sale_detail_id, print_qty: el.print_qty })
                }

            );
            let renderHtml = templatePrint(order, html)
            var config = {
                headers: {
                    'Content-Type': 'text/plain'
                },
                responseType: 'text'
            };
            await axios.post(getters.api_printer + `print?printer_name=${row.printer_name}`, renderHtml, config);
        }
        if (data_printed.length > 0) {
            Vue.notify({
                group: "notification",
                type: "info",
                speed: 500,
                duration: 5000,
                text: ("Printed to") + ' ' + printedRoom,
            });
            await AddQtyPrint({ data: data_printed })
        } else {
            Vue.notify({
                group: "notification",
                type: "warn",
                speed: 500,
                duration: 5000,
                text: 'Menu is already sent.',
            });
        }


        commit('PRINT_DETAILS', response)
    },
    async updateRoom({ commit, getters }, payload) {
        let room = getters.room_printers.findIndex(
            (x) => x.print_location_name == payload.print_location_name
        );
        getters.room_printers[room].printer_name = payload.printer_name;
        await updatePrinter(payload);

    },
    async printerTest({ commit, getters }, payload) {
        var config = {
            headers: {
                'Content-Type': 'text/plain'
            },
            responseType: 'text'
        };
        await axios.post(getters.api_printer + `print?printer_name=${payload.printer_name}`, payload.data, config);

    },
    async setSetting({ commit, getters }, payload) {
        commit('loadingSetting', true)
        const response = await userSetting(payload)
        commit('loadingSetting', false)
    },
    async getSetting({ commit, getters },) {
        const response = await getUserSetting()
        commit('Setting', response)
    },

}

function templatePrint(order, html) {
    let table = order.table || { name: 'None' }
    var fontsLaos = window.location.origin + "/" + require('@/assets/fonts/phetsarath_ot.woff')
    console.log(fontsLaos)
    var html = `<!DOCTYPE html>
                  <html lang="en">
                  <head>
                      <meta charset="UTF-8">
                      <meta http-equiv="X-UA-Compatible" content="IE=edge">
                      <meta name="viewport" content="width=device-width, initial-scale=1.0">
                      <title>Document</title> 
                      <link href="https://fonts.googleapis.com/css2?family=Battambang:wght@700&display=swap" rel="stylesheet">
                    
                      <style> 
                        @font-face {
                                        font-family: 'Phetsarath_OT'; 
                                        src: url('${fontsLaos}'); 
                                        font-weight: normal;
                                        font-style: normal; 
                        }

                        body{
                            font-family: 'Phetsarath_OT';
                            font-size: 25px; 
                            width: 560px;
                            line-height: 1.2; 
                        }
                        p{ margin: 1px;}
                        .bottline{
                              border-bottom: 2px dashed;
                              padding: 5px 5px;
                        }
                      </style>
                  </head>
                  <body >
                    <table>
                        <tr>
                            <td >Order Number: </td>
                            <td >${order.id}</td>                             
                        </tr> 
                        <tr>
                            <td >Table Number: </td>
                            <td >${table.name}</td>                             
                        </tr> 
                        <tr>
                            <td >Cashier: </td>
                            <td >${order.seller_name}</td>                             
                        </tr>
                        <tr>
                            <td >Print Date: </td>
                            <td >${moment().format("YYYY-MM-DD hh:mm A")}</td>                             
                        </tr>
                    </table>
                    <table style="width:100%"> 
                       
                        <tr>
                            <td class="bottline">SN</td> 
                            <td class="bottline">Item </td>
                            <td class="bottline">Qty</td>
                        </tr>
                        ${html} 
                    </table>
                  </body>
                  </html> `
    return html;
}